<div class="loading" *ngIf="show | async">
  <div class="spinner spinner-border text-primary" role="status">
    <span class="sr-only"> </span>
  </div>
</div>

